import React, { useState, useEffect } from "react";
import ReactExport from "react-export-excel";
import { translate } from 'react-multi-lang';
import { SyncOutlined, PercentageOutlined, LeftOutlined, EditOutlined, DeleteOutlined, SearchOutlined, FileExcelOutlined } from '@ant-design/icons';
import {Table, Tooltip, Popconfirm, Modal, Form, Row, Col, Select, Button, Input, InputNumber, Divider, Switch, DatePicker, Space, message } from 'antd';

import { AllHtmlEntities } from 'html-entities';
import moment from 'moment';
import 'moment/locale/ca';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const entities = new AllHtmlEntities();

function ComandesExcursionsExportaExcel(props){

  const [nursery, setNursery] = useState([]);
  const [reception, setReception] = useState([]);
  const [year1, setYear1] = useState([]);
  const [year2, setYear2] = useState([]);
  const [year34, setYear34] = useState([]);
  const [year56, setYear56] = useState([]);
  //const [year78, setYear78] = useState([]);
  const [secondary, setSecondary] = useState([]);

  const nom_fulla = props.nom_fulla ? props.nom_fulla : props.t('menu.ComandesSummerCamp');
  const nom_fitxer = props.nom_fitxer ? props.nom_fitxer : props.t('menu.ComandesSummerCamp')+'EXT';

  useEffect(() => {

    let fnursery_temp = [];
    let freception_temp = [];
    let fyear1_temp = [];
    let fyear2_temp = [];
    let fyear34_temp = [];
    let fyear56_temp = [];
    let fsecondary_temp = [];
    //let fyear78_temp = [];
    console.log('props.dades', props.dades)

    props.dades.forEach((comanda, i) => {

      if(comanda.estado === 'PENDIENTE PAGO'){
        return true;
      }
      comanda.json.nens.forEach((nen, i) => {
        nen.id_comanda = comanda.id;
        nen.estat = comanda.estado;
        nen.creat = comanda.fcrea;
        nen.alumne_complet = nen.nom+' '+nen.cognoms;
        nen.pare = comanda.json.pare;
        nen.pare2 = comanda.json.pare2;
        nen.permetre_publicitat = comanda.json.permetre_publicitat == true ? 'SI' : 'NO';
        nen.us_imatges = comanda.json.us_imatges == true ? 'SI' : 'NO';

        for(let i=3540; i<3707; i++ ){
          nen[`w${i}`] = 0;
        }

        if(nen.comprat && nen.comprat.propietats.weeks.w1 > 0){
          const p = nen.comprat.propietats.weeks.w1;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.weeks.w2 > 0){
          const p = nen.comprat.propietats.weeks.w2;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.weeks.w3 > 0){
          const p = nen.comprat.propietats.weeks.w3;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.weeks.w4 > 0){
          const p = nen.comprat.propietats.weeks.w4;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.weeks.w5 > 0){
          const p = nen.comprat.propietats.weeks.w5;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.weeks.w6 > 0){
          const p = nen.comprat.propietats.weeks.w6;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.bus.b1 > 0){
          const p = nen.comprat.propietats.bus.b1;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.bus.b2 > 0){
          const p = nen.comprat.propietats.bus.b2;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.bus.b3 > 0){
          const p = nen.comprat.propietats.bus.b3;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.bus.b4 > 0){
          const p = nen.comprat.propietats.bus.b4;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.bus.b5 > 0){
          const p = nen.comprat.propietats.bus.b5;
          nen[`w${p}`] = 1;
        }
        if(nen.comprat && nen.comprat.propietats.bus.b6 > 0){
          const p = nen.comprat.propietats.bus.b6;
          nen[`w${p}`] = 1;
        }

        if(nen.comprat){
          switch (nen.comprat.id_producte) {
            case 537:
              fnursery_temp.push(nen);
              break;
            case 538:
              freception_temp.push(nen);
              break;
            case 539:
              fyear1_temp.push(nen);
              break;
            case 540:
              fyear2_temp.push(nen);
              break;
            case 541:
              fyear34_temp.push(nen);
              break;
            case 542:
              fyear56_temp.push(nen);
              break;
            case 552:
              fsecondary_temp.push(nen);
              break;

            default:
          }
        }
      });

    });

    setNursery(fnursery_temp);
    setReception(freception_temp);
    setYear1(fyear1_temp);
    setYear2(fyear2_temp);
    setYear34(fyear34_temp);
    setYear56(fyear56_temp);
    setSecondary(fsecondary_temp);

  },[props.dades]);




  return (
    <ExcelFile
      filename={nom_fitxer}
      element={<Button type="primary" style={{backgroundColor: '#217346', borderColor: '#217346', marginBottom: '0.5rem', marginLeft: '0.5rem', marginRight: '0.5rem'}} shape="round" icon={<FileExcelOutlined />}>{props.btn_txt}</Button>}>
        <ExcelSheet data={nursery} name={'Nursery'}>
          <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
          <ExcelColumn label="Id_fill" value="id"/>
          <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
          <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
          <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
          <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
          <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

          <ExcelColumn label={'Setmana 1: 9h-16h (dinar)'} value="w3540"/>
          <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3541"/>
          <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
          <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
          <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

          <ExcelColumn label={'Setmana 2: 9h-16h (dinar)'} value="w3542"/>
          <ExcelColumn label={'Setmana 2: 9h a 13h'} value="w3543"/>
          <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
          <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
          <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

          <ExcelColumn label={'Setmana 3: 9h-16h (dinar)'} value="w3544"/>
          <ExcelColumn label={'Setmana 3: 9h a 13h'} value="w3545"/>
          <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
          <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
          <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

          <ExcelColumn label={'Setmana 4: 9h-16h (dinar)'} value="w3546"/>
          <ExcelColumn label={'Setmana 4: 9h a 13h'} value="w3547"/>
          <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
          <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
          <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

          <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3548"/>
          <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3549"/>
          <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
          <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
          <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

          <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3667"/>
          <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3668"/>
          <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
          <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
          <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>


            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>

          </ExcelSheet>

          <ExcelSheet data={reception} name={'Reception'}>
            <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
            <ExcelColumn label="Id_fill" value="id"/>
            <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
            <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
            <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
            <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
            <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

            <ExcelColumn label={'Setmana 1: 9h-16h (dinar)'} value="w3550"/>
            <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3551"/>
            <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
            <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
            <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

            <ExcelColumn label={'Setmana 2: 9h-16h (dinar)'} value="w3552"/>
            <ExcelColumn label={'Setmana 2: 9h a 13h'} value="w3553"/>
            <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
            <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
            <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

            <ExcelColumn label={'Setmana 3: 9h-16h (dinar)'} value="w3554"/>
            <ExcelColumn label={'Setmana 3: 9h a 13h'} value="w3555"/>
            <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
            <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
            <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

            <ExcelColumn label={'Setmana 4: 9h-16h (dinar)'} value="w3556"/>
            <ExcelColumn label={'Setmana 4: 9h a 13h'} value="w3557"/>
            <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
            <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
            <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

            <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3558"/>
            <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3559"/>
            <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
            <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
            <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

            <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3669"/>
            <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3670"/>
            <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
            <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
            <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>
            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>
          </ExcelSheet>

          <ExcelSheet data={year1} name={'Year 1'}>
            <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
            <ExcelColumn label="Id_fill" value="id"/>
            <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
            <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
            <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
            <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
            <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

            <ExcelColumn label={'Setmana 1: 9h-16h (dinar)'} value="w3560"/>
            <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3561"/>
            <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
            <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
            <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

            <ExcelColumn label={'Setmana 2: 9h-16h (dinar)'} value="w3562"/>
            <ExcelColumn label={'Setmana 2: 9h a 13h'} value="w3563"/>
            <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
            <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
            <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

            <ExcelColumn label={'Setmana 3: 9h-16h (dinar)'} value="w3564"/>
            <ExcelColumn label={'Setmana 3: 9h a 13h'} value="w3565"/>
            <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
            <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
            <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

            <ExcelColumn label={'Setmana 4: 9h-16h (dinar)'} value="w3566"/>
            <ExcelColumn label={'Setmana 4: 9h a 13h'} value="w3567"/>
            <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
            <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
            <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

            <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3568"/>
            <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3569"/>
            <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
            <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
            <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

            <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3671"/>
            <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3672"/>
            <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
            <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
            <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>
            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>
          </ExcelSheet>

          <ExcelSheet data={year2} name={'Year 2'}>
            <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
            <ExcelColumn label="Id_fill" value="id"/>
            <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
            <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
            <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
            <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
            <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

            <ExcelColumn label={'Setmana 1: 9h-16h (dinar)'} value="w3570"/>
            <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3571"/>
            <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
            <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
            <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

            <ExcelColumn label={'Setmana 2: 9h-16h (dinar)'} value="w3572"/>
            <ExcelColumn label={'Setmana 2: 9h a 13h'} value="w3573"/>
            <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
            <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
            <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

            <ExcelColumn label={'Setmana 3: Sailing 9h-16h'} value="w3574"/>
            <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
            <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
            <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

            <ExcelColumn label={'Setmana 4: 9h-16h (dinar)'} value="w3575"/>
            <ExcelColumn label={'Setmana 4: 9h a 13h'} value="w3576"/>
            <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
            <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
            <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

            <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3577"/>
            <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3578"/>
            <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
            <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
            <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

            <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3673"/>
            <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3674"/>
            <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
            <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
            <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>
            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>
          </ExcelSheet>

          <ExcelSheet data={year34} name={'Year 3,4'}>
            <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
            <ExcelColumn label="Id_fill" value="id"/>
            <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
            <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
            <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
            <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
            <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

            <ExcelColumn label={'Setmana 1: 9h-16h (dinar)'} value="w3579"/>
            <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3580"/>
            <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
            <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
            <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

            <ExcelColumn label={'Setmana 2: Sailing 9h-16h'} value="w3581"/>
            <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
            <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
            <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

            <ExcelColumn label={'Setmana 3: 9h-16h (dinar)'} value="w3582"/>
            <ExcelColumn label={'Setmana 3: 9h a 13h'} value="w3583"/>
            <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
            <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
            <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

            <ExcelColumn label={'Setmana 4: 9h-16h (dinar)'} value="w3584"/>
            <ExcelColumn label={'Setmana 4: 9h a 13h'} value="w3585"/>
            <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
            <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
            <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

            <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3586"/>
            <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3587"/>
            <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
            <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
            <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

            <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3675"/>
            <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3676"/>
            <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
            <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
            <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>
            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>
          </ExcelSheet>

          <ExcelSheet data={year56} name={'Year 5,6'}>
            <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
            <ExcelColumn label="Id_fill" value="id"/>
            <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
            <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
            <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
            <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
            <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

            <ExcelColumn label={'Setmana 1: 9h a 16h (Dinar)'} value="w3588"/>
            <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3589"/>
            <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
            <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
            <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

            <ExcelColumn label={'Setmana 2: 9h a 16h (Dinar)'} value="w3677"/>
            <ExcelColumn label={'Setmana 2: 9h a 13h'} value="w3594"/>
            <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
            <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
            <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

            <ExcelColumn label={'Setmana 3: 9h a 16h (Dinar)'} value="w3591"/>
            <ExcelColumn label={'Setmana 3: 9h a 13h'} value="w3592"/>
            <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
            <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
            <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

            <ExcelColumn label={'Setmana 4: Sailing 9h-16h'} value="w3590"/>
            <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
            <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
            <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

            <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3595"/>
            <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3596"/>
            <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
            <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
            <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

            <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3593"/>
            <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3678"/>
            <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
            <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
            <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>
            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>
          </ExcelSheet>

          <ExcelSheet data={secondary} name={'Secondary'}>
            <ExcelColumn label="Id_comanda"  value={'id_comanda'}/>
            <ExcelColumn label="Id_fill" value="id"/>
            <ExcelColumn label={props.t('botiga.titolEstat')} value={(col) => col.estat}/>
            <ExcelColumn label={props.t('botiga.producte')} value={(col) => entities.decode(col.nom[props.t('idioma')])}/>
            <ExcelColumn label={props.t('alumnes.classe')} value={(col) => entities.decode(col.classe)}/>
            <ExcelColumn label={props.t('generic.alumne')} value={(col) => entities.decode(col.alumne_complet)}/>
            <ExcelColumn label={props.t('generic.total')} value={(col) => parseFloat(col.total)}/>

            <ExcelColumn label={'Setmana 1: 9h a 16h (Dinar)'} value="w3682"/>
            <ExcelColumn label={'Setmana 1: 9h a 13h'} value="w3683"/>
            <ExcelColumn label={'Setmana 1: bus anada'} value="w3612"/>
            <ExcelColumn label={'Setmana 1: bus tornada'} value="w3617"/>
            <ExcelColumn label={'Setmana 1: bus anada i tornada'} value="w3607"/>

            <ExcelColumn label={'Setmana 2: 9h a 16h (Dinar)'} value="w3684"/>
            <ExcelColumn label={'Setmana 2: 9h a 13h'} value="w3685"/>
            <ExcelColumn label={'Setmana 2: bus anada'} value="w3613"/>
            <ExcelColumn label={'Setmana 2: bus tornada'} value="w3618"/>
            <ExcelColumn label={'Setmana 2: bus anada i tornada'} value="w3608"/>

            <ExcelColumn label={'Setmana 3: Exploring Llauset 9h-16h'} value="w3686"/>
            <ExcelColumn label={'Setmana 3: bus anada'} value="w3614"/>
            <ExcelColumn label={'Setmana 3: bus tornada'} value="w3619"/>
            <ExcelColumn label={'Setmana 3: bus anada i tornada'} value="w3609"/>

            <ExcelColumn label={'Setmana 4: 9h a 16h (Dinar)'} value="w3687"/>
            <ExcelColumn label={'Setmana 4: 9h a 13h'} value="w3688"/>
            <ExcelColumn label={'Setmana 4: bus anada'} value="w3615"/>
            <ExcelColumn label={'Setmana 4: bus tornada'} value="w3620"/>
            <ExcelColumn label={'Setmana 4: bus anada i tornada'} value="w3610"/>

            <ExcelColumn label={'Setmana 5: 9h-16h (dinar)'} value="w3689"/>
            <ExcelColumn label={'Setmana 5: 9h a 13h'} value="w3690"/>
            <ExcelColumn label={'Setmana 5: bus anada'} value="w3616"/>
            <ExcelColumn label={'Setmana 5: bus tornada'} value="w3621"/>
            <ExcelColumn label={'Setmana 5: bus anada i tornada'} value="w3611"/>

            <ExcelColumn label={'Setmana 6: 9h-16h (dinar)'} value="w3691"/>
            <ExcelColumn label={'Setmana 6: 9h a 13h'} value="w3692"/>
            <ExcelColumn label={'Setmana 6: bus anada'} value="w3680"/>
            <ExcelColumn label={'Setmana 6: bus tornada'} value="w3681"/>
            <ExcelColumn label={'Setmana 6: bus anada i tornada'} value="w3679"/>

            <ExcelColumn label={props.t('generic.created_at')} value={(col) => moment(col.creat).tz('Europe/Madrid').format('DD/MM/YYYY')}/>

            {/* Dades alumne */}
            <ExcelColumn label="CatSalut" value={(col) => entities.decode(col.catsalut)}/>
            <ExcelColumn label="Alergia" value={(col) => entities.decode(col.alergia)}/>
            <ExcelColumn label="Intolerancia" value={(col) => entities.decode(col.intolerancia)}/>
            <ExcelColumn label="Malalties" value={(col) => entities.decode(col.malalties)}/>
            <ExcelColumn label="Medicacio" value={(col) => entities.decode(col.medicacio)}/>
            <ExcelColumn label="Nascut" value={(col) => moment(col.naixement).tz('Europe/Madrid').format('DD/MM/YYYY')}/>
            <ExcelColumn label="Publicitat" value={(col) => entities.decode(col.permetre_publicitat)}/>
            <ExcelColumn label="UsImatges" value={(col) => entities.decode(col.us_imatges)}/>
            {/* Dades Pare1 */}
            <ExcelColumn label="Pare1 Nom" value={(col) => entities.decode(col.pare.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare.tel2)}/>
            <ExcelColumn label="email" value={(col) => entities.decode(col.pare.email)}/>
            <ExcelColumn label="Adress" value={(col) => entities.decode(col.pare.adress)}/>
            {/* Dades Pare2 */}
            <ExcelColumn label="Pare2 Nom" value={(col) => entities.decode(col.pare2.nom)}/>
            <ExcelColumn label="Cognoms" value={(col) => entities.decode(col.pare2.cognoms)}/>
            <ExcelColumn label="Tel1" value={(col) => entities.decode(col.pare2.tel1)}/>
            <ExcelColumn label="Tel2" value={(col) => entities.decode(col.pare2.tel2)}/>
          </ExcelSheet>


      </ExcelFile>
  );

}

export default translate(ComandesExcursionsExportaExcel);
